export const track = (name, payload) => {
  if (typeof window !== 'undefined') {
    window.LIFE_CYCLE_EVENT_BUS.trigger(name, payload);
  }
};

export const lifeCycleTrack = (name, payload) => {
  if (typeof window !== 'undefined') {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger(name, payload);
  }
};
